module.exports = __webpack_public_path__ + "img/ex (3).063d9512.jpeg";